import { useBasicPopup } from '../../../components/basic/popup/BasicPopup'
import { useBottomSheet } from '../../../components/basic/popup/BottomSheet'
import TutorModal from '../../../components/modal/TutorModal'
import TutorSelectButton from '../../../components/trial/TutorSelectButton'
import apis from '../../apis'
import { axiosGet } from '../../axiosHelper'
import { s_lesson_review } from '../../i18n/strings/auto/wording'
import useTranslation from '../../i18n/useTranslation'
import { AUTO_MATHCING_ID } from '../../vars'
import useIsMobile from './useIsMobile'

interface ITutorPopup {
  event: any
  tutorId: any
  isTrial?: boolean
}
export const useOpenLandingTutorPopup = (props: any = {}) => {
  const { t, locale } = useTranslation()
  const basicPopup = useBasicPopup()
  const bottomSheet = useBottomSheet()
  const isMobile = useIsMobile()

  return async ({ event, tutorId, isTrial = false }: ITutorPopup) => {
    try {
      event.preventDefault()
      event.stopPropagation()

      if (tutorId == AUTO_MATHCING_ID) return
      const res = await axiosGet(apis.tutor.profile(tutorId, locale))

      if (res.success) {
        if (isMobile) {
          bottomSheet.show({
            id: 'tutor-bottom-sheet',
            noScrollbar: true,
            body: (
              <div className="max-h-[90vh]">
                <TutorModal data={res.tutor} isTrial={isTrial} isMobile={isMobile} />
              </div>
            ),
            bottombarContent: isTrial && (
              <div className="z-2000 fixed bottom-0 left-0 flex h-[104px] w-full items-start justify-center bg-white px-[16px] pt-[12px]">
                <TutorSelectButton tutorId={tutorId} />
              </div>
            ),
          })
        } else {
          basicPopup.show({
            id: 'splitTutorModal',
            maxW: 1096,
            overlayClose: true,
            maxH: '84%',
            bodyPb: isTrial ? 24 : 40,
            titlePx: 40,
            title: (
              <>
                <span className="text-gray-700">{t(s_lesson_review.tutor)} </span>
                <span>{res.tutor?.name}</span>
              </>
            ),
            wrapperClassName: isTrial
              ? 'border-1 rounded-[4px] border-gray-200 mx-[40px] px-[60px] !max-h-[calc(84vh_-_204px)] mb-[24px]'
              : 'border-1 rounded-[4px] border-gray-200 mx-[40px] px-[60px] !max-h-[calc(84vh_-_124px)] mb-[40px]',
            body: <TutorModal data={res.tutor} isTrial={isTrial} isMobile={isMobile} />,
            bottomButton: isTrial && (
              <div className="w-ful flex justify-end pr-[40px] pb-[40px]">
                <TutorSelectButton tutorId={tutorId} />
              </div>
            ),
          })
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}
